module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Layout Affiliate  */
(function(fox, $) {
	'use strict';

	fox.registerWidget('Layout_Affiliate', {
		configure: function(options) {
			this.registerOptions('', {
				pageContainer: '#aff-container',
				widgets: {
					loginApi: {
						widget: 'Api',
						address: '/affiliates/api.php',
						method: 'affiliate.authorizer.auth'
					},
					recoveryPassApi: {
						widget: 'Api',
						address: '/affiliates/api.php',
						method: 'passwordRecovery.sendRecoveryMail',
						handleWom: {
							recoveryApiResponse: {
								event: ['success', 'error', 'failure'],
								widget: '@this',
								callback: '@parent:recoveryApiResponse'
							}
						}
					},
					clientDataApi: {
						widget: 'Api',
						address: '/affiliates/api.php',
						method: 'affiliate.getModelFrontData',
						'handleWom.cdaApiSuccess': {
							event: 'success',
							widget: '@this',
							callback: '@parent:cdaApiSuccess'
						}
					},
					recoveryPass: {
						widget: 'Widget',
						active: false,
						group: 'popup',
						autoRender: true,
						'embed.container': '#aff-popup-container',
						template: 'sitepage_affiliates_popup_pass_recovery',
						'widgets.recoveryForm': {
							widget: 'Form',
							loadValuesOnRun: false,
							autoApply: true,
							formElements: {
								email: {element: '[name=recpassemail]'}
							},
							submit: {
								event: 'click',
								target: '#aff-pass-request'
							},
							'hooks.onSubmit': '@parent @parent:onPassRecovery',
							'widgets.validator': {
								widget: 'Easy_Form_Validator',
								hangClassLocation: 'parentNode',
								requiredFields: ['email'],
								formWidget: '@parent',
								defaultValidator: [{
									validator: 'length',
									options: {min: 1},
									message: 'This field is required'
								}]
							}
						}
					},
					loginForm1: {
						widget: 'Form',
						loadValuesOnRun: false,
						autoApply: true,
						formElements: {
							email1: {element: '[name=email1]'},
							passwd1: {element: '[name=passwd1]'}
						},
						submit: {
							event: 'click',
							target: '#aff-login'
						},
						'hooks.onSubmit': '@parent:onLogin',
						'widgets.validator': {
							widget: 'Easy_Form_Validator',
							hangClassLocation: 'parentNode',
							requiredFields: ['email1', 'passwd1'],
							formWidget: '@parent',
							defaultValidator: [{
								validator: 'length',
								options: {min: 1},
								message: 'This field is required'
							}]
						}
					},
					loginError: {
						widget: 'Widget',
						autoRender: true,
						active: false,
						group: 'popup',
						'embed.container': '#aff-popup-container',
						template: 'sitepage_affiliates_popup_login_error'
					},
					popupLogin: {
						widget: 'Widget',
						autoRender: true,
						active: true,
						group: 'popup',
						'embed.container': '#aff-popup-container',
						template: 'sitepage_affiliates_popup_login_form',
						'widgets.loginForm2': {
							widget: 'Form',
							loadValuesOnRun: false,
							autoApply: true,
							formElements: {
								email2: {element: '[name=email2]'},
								passwd2: {element: '[name=passwd2]'}
							},
							submit: {
								event: 'click',
								target: '#aff-login-on-popup'
							},
							'hooks.onSubmit': '@parent @parent:onLogin',
							'widgets.validator': {
								widget: 'Easy_Form_Validator',
								hangClassLocation: 'parentNode',
								requiredFields: ['email2', 'passwd2'],
								formWidget: '@parent',
								defaultValidator: [{
									validator: 'length',
									options: {min: 1},
									message: 'This field is required'
								}]
							}
						}
					}
				},
				handleWom: {
					loginApiResponse: {
						widget: '#loginApi',
						event: ['success', 'failure'],
						callback: '_loginApiResponse'
					}
				},
				handleDom: {
					showLoginForm: {
						event: 'click',
						target: ['#aff-fake-login', '#aff-close-login-popup'],
						callback: 'showHideLoginForm'
					},
					tryLoginAgain: {
						event: 'click',
						target: '#aff-login-try-again',
						targetWidget: '#loginError',
						callback: 'tryLoginAgain'
					},
					clickOnDesktop: {
						event: 'click',
						target: '#aff-login',
						callback: function () {
							this.clickOnDesktop = true;
						}
					},
					passRecovery: {
						event: 'click',
						target: '.forgot',
						callback: 'passRecovery'
					},
					passRecovery2: {
						event: 'click',
						target: '.forgot',
						targetWidget: '#popupLogin',
						callback: 'passRecovery'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.clickOnDesktop = false;	
		
			this.callParent('init', arguments);
		},

		onLogin: function (formData) {
			var data = {};

			fox.each(formData, function (val, alias) {
				var a = alias.slice(0, -1);

				data[a] = fox.trim(val);
			});

			this.rwom1('#loginApi').send(data, false);
		},

		_loginApiResponse: function (data) {
			var response = data.answer.response;

			if (!data.answer.status) {
				this.showLoginError();

				return;
			}

			if (response && !response.member) {
				return;
			}

			document.location.href = 'https://centroprofits.com';
		},

		showHideLoginForm: function (el) {
			var popup, overlay;
			
			if (el && el.getAttribute('id') === 'aff-fake-login' &&
				!this.rwom1('#popupLogin').isActive()) {
				this.switchEmbeddedWidget('popupLogin');
			}

			popup = this.dom1('#aff-login-popup');
			overlay = this.dom1('.aff-overlay');

			if ($(popup).is(':visible') && $(overlay).is(':visible')) {
				$(popup).removeClass('bounceInDown').addClass('bounceOutUp');
				$(overlay).removeClass('fadeIn').addClass('fadeOut');

				setTimeout(function () {
					$(popup).removeClass('visible animated bounceOutUp');
					$(overlay).removeClass('visible animated fadeOut');
				}, 1000);
			} else {
				$(popup).addClass('visible animated bounceInDown');
				$(overlay).addClass('visible animated fadeIn');
			}
		},

		showLoginError: function () {
			var popup;

			popup = this.dom1('#aff-login-popup');

			if (!this.rwom1('#loginError').isActive()) {
				this.switchEmbeddedWidget('loginError');
			}

			if (!$(popup).is(':visible')) {
				this.showHideLoginForm();
			}
		},

		tryLoginAgain: function () {
			if (this.clickOnDesktop === true) {
				this.showHideLoginForm();
				this.clickOnDesktop = false;

				return;
			}

			if (this.rwom1('#loginError').isActive()) {
				this.switchEmbeddedWidget('popupLogin');
			}
		},

		passRecovery: function () {
			var popup;

			popup = this.dom1('#aff-login-popup');

			this.switchEmbeddedWidget('recoveryPass');

			if (!$(popup).is(':visible')) {
				this.showHideLoginForm();
			}
		},

		onPassRecovery: function (formData) {
			formData.domainProd = 1;
			this.rwom1('#recoveryPassApi').send(formData);
		},

		recoveryApiResponse: function (res) {
			var label;

			res = res.answer.response;
			
			if (res.success === false) {
				label = this.rwom1('#recoveryPass').dom1('label');
				label.innerText = res.text;
				fox.dom.addClass('error', label.parentNode);
			} else {
				this.showHideLoginForm();
			}
		},

		render: function () {
			if (!this.clientData) {
				this.getClientData();
			} else {
				this.setTemplateOptions(this.clientData);
				this.callParent('render', arguments);
				this.rwom1('.Site_Page').render();
			}
		},

		getClientData: function () {
			//this.rwom1('#clientDataApi').send(); fix for AMC-17575

			return this;
		},

		cdaApiSuccess: function (res) {
			this.clientData = res.answer.response;

			this.render();
		}

	}, 'Site_Layout');

})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/affiliate/widget/layout/affiliate.js
// module id = 179
// module chunks = 4